export default "__VITE_ASSET__4cc9d17a__$_?nuxt_component=async&nuxt_component_name=SvgoFreepancake__"